export default __webpack_public_path__ + "static/media/UY.7b22dc2d.svg";